import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { align: "center" }
const _hoisted_2 = {
  class: "text-h5 font-weight-bold mb-4 mt-2",
  align: "center"
}
const _hoisted_3 = {
  class: "mb-8",
  style: {"font-size":"15px"}
}
const _hoisted_4 = { align: "end" }
const _hoisted_5 = { align: "center" }
const _hoisted_6 = {
  class: "text-h5 font-weight-bold mb-2 mt-2",
  align: "center"
}
const _hoisted_7 = {
  class: "mb-1",
  style: {"font-size":"15px"}
}
const _hoisted_8 = {
  class: "mb-2",
  style: {"font-size":"15px"}
}
const _hoisted_9 = { align: "end" }

import { useI18n } from 'vue-i18n'
import { computed, ref } from 'vue'
import { Connection, DoctorProfile, RequestResponse } from '@/types'
import HeaderComponent from '../Header/HeaderComponent.vue'
import router from '@/router'
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useUserActions } from '@/stores/user-actions'
import { broadcastingActions } from '@/stores/broadcasting-store'


export default /*#__PURE__*/_defineComponent({
  __name: 'SubscribeComponent',
  props: {
    photo: {},
    name: {}
  },
  emits: ['subscribed', 'unsubscribed'],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n()
const isLoading = ref(false)
const route = useRoute()
const props = __props
const docPhoto = ref(props.photo)
const docName = ref(props.name)
const id = ref()
const subscribe = ref(false)
const subscribed = ref(false)
const broadcasting = broadcastingActions()
const requestResponse = ref<RequestResponse>()
const connectionId = ref<string>('')

const emit = __emit
onMounted(async () => {
  isLoading.value = true
  id.value = route.params.id
  const token = localStorage.getItem('accessToken') ?? null
  if (token) {
    const response = await broadcasting.checkSubscription(token, id.value)
    const status = response.result as Connection
    if (status.connected) {
      subscribed.value = true
      connectionId.value = status.connectionId as string
    }
  }
  isLoading.value = false
})

const subscribeToDoctor = () => {
  const token = localStorage.getItem('accessToken') ?? null
  if (!token) {
    localStorage.setItem('docId', id.value)
    router.push('/login')
  }
  subscribe.value = !subscribe.value
}

const subscribeOrUnsubscribeToDoctor = async () => {
  if (!subscribed.value) {
    isLoading.value = true
    const response = await broadcasting.subscribeToDoctor(id.value)
    requestResponse.value = response
    connectionId.value = response?.result?.connectionId
    subscribed.value = response.success
    emit('subscribed', { val: requestResponse.value, subscribed: true })

    subscribe.value = false
    isLoading.value = false
  } else {
    isLoading.value = true
    const response = await broadcasting.unSubscribeToDoctor(connectionId.value)
    requestResponse.value = response
    subscribed.value = !response.success
    emit('subscribed', { val: requestResponse.value, subscribed: false })
    subscribe.value = false
    isLoading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_btn, {
      modelValue: subscribe.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((subscribe).value = $event)),
      class: "mt-4 ml-4",
      color: "#3fb984",
      height: "40",
      loading: isLoading.value,
      onClick: subscribeToDoctor
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, {
          size: "30",
          class: "mr-2"
        }, {
          default: _withCtx(() => [
            _createTextVNode("mdi-radio-tower")
          ]),
          _: 1
        }),
        _createTextVNode(" " + _toDisplayString(!subscribed.value ? _ctx.$t('subscribe') : _ctx.$t('unsubscribe')), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "loading"]),
    (!subscribed.value)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 0,
          modelValue: subscribe.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((subscribe).value = $event)),
          persistent: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_sheet, {
              border: "md",
              class: "pa-6 text-black mx-auto",
              color: "white",
              "max-width": "450px",
              style: {"border-radius":"7%"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_v_img, {
                    src: docPhoto.value,
                    width: "100px",
                    style: {"border-radius":"50%"}
                  }, null, 8, ["src"])
                ]),
                _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t('subscribe-header')) + " " + _toDisplayString(docName.value), 1),
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('subscription-line-1')) + " " + _toDisplayString(docName.value) + " " + _toDisplayString(_ctx.$t('subscription-line-2')), 1),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_v_btn, {
                    color: "error",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (subscribe.value = false)),
                    icon: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-cancel")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    class: "ml-3",
                    color: "#3fb984",
                    onClick: subscribeOrUnsubscribeToDoctor,
                    icon: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-check")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (subscribed.value)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 1,
          modelValue: subscribe.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((subscribe).value = $event)),
          persistent: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_sheet, {
              border: "md",
              class: "pa-6 text-black mx-auto",
              color: "white",
              "max-width": "450px",
              style: {"border-radius":"7%"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_v_img, {
                    src: docPhoto.value,
                    width: "100px",
                    style: {"border-radius":"50%"}
                  }, null, 8, ["src"])
                ]),
                _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t('unsubscribe-header-en')) + " " + _toDisplayString(docName.value) + _toDisplayString(_ctx.$t('unsubscribe-header-de')), 1),
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('unsubscribe-line-1')) + " " + _toDisplayString(docName.value), 1),
                _createElementVNode("p", _hoisted_8, _toDisplayString(docName.value) + " " + _toDisplayString(_ctx.$t('unsubscribe-line-2')), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_v_btn, {
                    color: "error",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (subscribe.value = false)),
                    icon: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-cancel")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    class: "ml-3",
                    color: "#3fb984",
                    onClick: subscribeOrUnsubscribeToDoctor,
                    icon: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-check")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})